import { CoreApi, DistanceMeasurementSystem } from '@inter-ikea-storageone/range';
import { Feature, ShouldReset } from '../../../features/Feature';

export class DistanceMeasurementFeature extends Feature implements ShouldReset {
  private coreApi: CoreApi | null = null;

  protected init(coreApi: CoreApi): void {
    this.coreApi = coreApi;
    coreApi.registerSystem(new DistanceMeasurementSystem(coreApi));
  }
  reset(): void {
    this.coreApi
      ?.getSystem<DistanceMeasurementSystem>('DistanceMeasurementSystem')
      ?.onRemoveLines();
  }
}
